<template>
  <el-dialog
    class="area"
    title="线路输入服务器信息修改"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
  >
    <div class="list">
      <div class="li">
        <div class="info">
          <div class="left">线路输入服务器ip:</div>
          <div class="right">
            <el-input
              v-model.trim="liserverip"
              size="small"
              placeholder="请输入线路输入服务器ip:"
            >
              <el-button
                class="btn"
                slot="append"
                type="primary"
                @click="editBroadcastLineIp"
                >确定</el-button
              ></el-input
            >
          </div>
        </div>
        <div class="info">
          <div class="left">播放优先级:</div>
          <div class="right">
            <el-select
              v-model="sourceIndex"
              size="small"
              placeholder="请选择播放优先级"
              @change="setBroadcastLineIndex"
            >
              <el-option
                v-for="item in sourceList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
            <span class="tip">(数字越小优先级越高)</span>
          </div>
        </div>
        <div class="info">
          <div class="left">自动打开状态:</div>
          <div class="right">
            <el-radio-group class="brand-group" v-model="autoopen" size="mini">
              <el-radio :label="1" @click.native.prevent="sel(1)"
                >自动打开</el-radio
              >
              <el-radio :label="2" @click.native.prevent="sel(2)"
                >不自动打开</el-radio
              >
            </el-radio-group>
          </div>
        </div>
      </div>
    </div>
    <!-- <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        @click="submit"
        >确 定</el-button
      >
    </span> -->
  </el-dialog>
</template>

<script>
export default {
  name: "BroadcastBindingArea",
  components: {},
  props: {
    areaNum: {
      type: String,
      default: {
        return: ""
      }
    },
    lineResize: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      resData: {
        id: "",
        areaName: "",
        areaNum: "",
        subregions: []
      },
      sourceList: [1, 2, 3, 4, 5, 6, 7, 8],
      sourceIndex: 1, // 1/2/3/4/5//6/7/8 播放优先级 数字越小优先级越高
      liserverip: "",
      autoopen: 1 // 1 自动打开, 2 不自动打开
    };
  },
  created() {},
  mounted() {},
  watch: {
    lineResize: function(newVal, oldVal) {
      if (newVal) {
        this.getBroadcastLineIp();
        this.getBroadcastLineAuto();
        this.dialogVisible = true;
      }
    }
  },
  computed: {},
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.clearData();
    },
    clearData() {
      this.sourceIndex = 1;
    },
    submit() {
      // if (this.selectBroadcastCatalogIdTemp == "") {
      //   this.$message("请选择资源广播！");
      //   return;
      // }
      this.editBroadcastBindingArea();
      this.dialogVisible = false;
    },
    sel(num) {
      let name = "";
      if (num == 1) {
        name = "自动打开";
      } else {
        name = "不自动打开";
      }
      this.$confirm("您确认要将线路切换为" + name + "状态吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.autoopen = num;
          this.editBroadcastLineAuto();
        })
        .catch(() => {});
    },

    // 获取云广播线路输入服务器ip
    async getBroadcastLineIp() {
      let req = {
        gatewayId: this.areaNum
      };
      let res = await this.$Http.getBroadcastLineIp(req);
      if (res.code == 200) {
        this.liserverip = res.data.liserverip;
      } else if (res.code == 101) {
        this.liserverip = "";
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取云广播自动线路输入自动打开状态
    async getBroadcastLineAuto() {
      let req = {
        gatewayId: this.areaNum
      };
      let res = await this.$Http.getBroadcastLineAuto(req);
      if (res.code == 200) {
        this.autoopen = res.data.autoopen;
      } else if (res.code == 101) {
        this.autoopen = 1;
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 设置云广播服务器线路输入序号
    async setBroadcastLineIndex() {
      let req = {
        gatewayId: this.areaNum,
        sourceIndex: this.sourceIndex
      };
      let res = await this.$Http.setBroadcastLineIndex(req);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "修改成功！"
        });
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 编辑云广播线路输入服务器ip
    async editBroadcastLineIp() {
      if (this.liserverip == "") {
        this.$message("请输入线路服务器ip！");
        return;
      }
      let req = {
        gatewayId: this.areaNum,
        liserverip: this.liserverip
      };
      let res = await this.$Http.editBroadcastLineIp(req);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "修改成功！"
        });
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 设置云广播自动线路输入自动打开状态
    async editBroadcastLineAuto() {
      let req = {
        gatewayId: this.areaNum,
        autoopen: this.autoopen
      };
      let res = await this.$Http.editBroadcastLineAuto(req);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "修改成功！"
        });
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.list {
  padding: 10px 40px;
  height: 300px;
  overflow: scroll;
  .li {
    margin-bottom: 20px;
  }
  .info {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 15px 5px;
  }
  .left {
    width: 120px;
  }
  .right {
    .el-input {
      width: 298px;
      /deep/ .el-input-group__append {
        border: none;
        .btn {
          padding: 9px 20px;
          color: #ffffff;
          background-color: #409eff;
          border-color: #409eff;
          &:focus {
            outline: none;
          }
        }
      }
    }
    .el-select {
      width: 230px;
    }
    .tip {
      display: inline-block;
      padding-left: 10px;
      font-size: 12px;
      color: #969696;
    }
  }
}
.no-data {
  padding: 10px 40px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
